
import NavLink from './NavLink'
import { mapState } from 'vuex'

export default {
  name: 'MainNav',
  components: {
    NavLink
  },
  props: {
    menu: {
      type: Array,
      default: []
    }
  },
  computed: {
    ...mapState(['appInfo', 'user'])
  }
}
